<template>
    <li class="taskItemWrap">
        <section v-if="status === 1 " class="el-alert ">
            <i class="el-alert__icon icon success el-icon-circle-check"></i>
            <div class="el-alert__content taskContent">
                <h4 class="">成功生成“{{name}}”</h4>
                <p class="tips">{{createTimeStr}}</p>
                <el-button 
                    class="btn" 
                    type = 'primary'
                    @click="downloadfile(id,groupId)"
                >下载</el-button>
            </div>
        </section>
        <section v-else-if="status === 0 " class="el-alert ">
            <i class="el-alert__icon icon el-icon-loading"></i>
            <div class="el-alert__content taskContent">
                <h4 class="">正在生成“{{name}}”</h4>
                <p class="tips">{{createTimeStr}}</p>
                <el-button class="btn" @click="cancelTask(id,groupId)">取消</el-button>
            </div>
        </section>
        <section v-else-if="status === 2 "  class="el-alert ">
            <i class="el-alert__icon icon error el-icon-circle-close"></i>
            <div class="el-alert__content taskContent">
                <h4 class="">生成失败“{{name}}”</h4>
                <p class="errorTip tips">网络有误</p>
                <p class="tips">{{createTimeStr}}</p>
            </div>
        </section>
    </li> 
</template>
<script>
import { Message } from 'element-ui'
import { download } from '../plugins/helper'
export default {
    name: 'TaskItem',
    componentName: 'TaskItem',
    props: ['createName','createTimeStr','id','name','resourceKey','status','type','groupId'],
    methods: {
    downloadfile: function (id,groupId) {
      try {
        download(`/eos/coupon/task/downloadFile?id=${id}&groupId=${groupId}`)
        //  console.log(`/eos/coupon/task/downloadFile?id=${id}&groupId=${groupId}`)
      } catch (e) {
        Message.error('手机号模版下载失败')
      }
    },
    cancelTask:function(id,groupId){
        this.$store.dispatch('header/cancelTask', {
          groupId,id
        })
    }
  }
}
</script>
<style scoped lang="stylus">
.taskItemWrap{
    .icon{
        font-size 38px;
        width 38px;
        position absolute
        top 18px
        
    }
    .taskContent{
        position relative
        width: 100%;
        padding: 10px 0px 10px 60px;
    }
    .btn{
        position absolute
        right 0
        top 10px;
        padding: 8px 20px;
    }
    .success{
        color #67c23a;
        
    }
    .error{
        color red
    }
    .errorTip{
        margin-bottom: 10px;
    }
    h4{
        font-size:14px;
        font-weight :bold;
        // padding-top: 15px;
        padding-bottom: 3px;
    }
    .tips{
        font-size 12px;
        color #9b9b9b
    }
}

</style>
   